import quote from "./images/quote.png";
import atomPro from "./images/atomPro.svg";
import mail from "./images/mail.svg";
import logo from "./images/logo.svg";
import atomByViderLogo from "./images/atomByViderLogo.png";
import loginBg from "./images/login_bg.png";
import whiteLogo from "./images/white_logo.svg";
import dashboard from "./icons/dashboard.svg";
import approvals from "./icons/approvals.svg";
import taskboard from "./icons/taskboard.svg";
import calendar from "./icons/calendar.svg";
import checklist_PosterImage from "./icons/checklist_PosterImage.png";
import handshake_PosterImage from "./icons/handshake_PosterImage.png";
import socialmedia_PosterImage from "./icons/socialmedia_PosterImage.png";
import calendar_PosterImage from "./icons/calendar_PosterImage.png";
import taskCompleted from "./icons/taskCompleted.svg";
import totalClients from "./icons/totalClients.svg";
import taskInprogress from "./icons/taskInprogress.svg";
import taskTodo from "./icons/taskTodo.svg";
import taskUnderReview from "./icons/taskUnderReview.svg";
import totalTasks from "./icons/totalTasks.svg";
import invoicing from "./icons/invoicing.svg";
import clients from "./icons/clients.svg";
import register from "./icons/register.svg";
import dsc from "./icons/dsc.svg";
import gstReturns from "./icons/gstReturns.svg";
import storage from "./icons/storage.svg";
import team from "./icons/team.svg";
import reports from "./icons/reports.svg";
import settings from "./icons/settings.svg";
import broadcast from "./icons/broadcast.svg";
import logout from "./icons/logout.svg";
import man from "./icons/man.svg";
import profile from "./icons/profile.svg";
import date from "./icons/calendar.png";
import shuffle from "./icons/shuffle.svg";
import formIcon from "./icons/formIcon.svg";
import empty from "./images/empty.svg";
import user from "./icons/user.png";
import folder from "./icons/folder.png";
import pdf from "./icons/filetypes/pdf.png";
import doc from "./icons/filetypes/docs.png";
import excel from "./icons/filetypes/excel.png";
import csv from "./icons/filetypes/csv.png";
import text from "./icons/filetypes/text.png";
import ppt from "./icons/filetypes/ppt.png";
import zip from "./icons/filetypes/zip.png";
import video from "./icons/filetypes/video.png";
import audio from "./icons/filetypes/audio.png";
import recurring from "./icons/recurring.svg";
import singleLine from "./icons/singleLine.svg";
import email from "./icons/email.svg";
import address from "./icons/address.svg";
import multiLine from "./icons/multiLine.svg";
import name from "./icons/name.svg";
import checkBox from "./icons/checkBox.svg";
import fileUpload from "./icons/fileUpload.svg";
import imageUpload from "./icons/imageUpload.svg";
import termsAndConditions from "./icons/termsAndConditions.svg";
import currency from "./icons/currency.svg";
import signature from "./icons/signature.svg";
import dropDown from "./icons/dropDown.svg";
import decisionBox from "./icons/decisionBox.svg";
import fieldDate from "./icons/date.svg";
import mobileNumber from "./icons/mobileNumber.svg";
import numbers from "./icons/number.svg";
import profileImage from "./images/profile.jpg";
import noAttachments from "./images/no_attachments.svg";
import noSubTasks from "./images/noSubTasks.svg";
import noChecklists from "./images/noChecklists.svg";
import noMilestones from "./images/noMilestones.svg";
import noDueDiligence from "./images/noDueDiligence.svg";
import noEvents from "./images/noEvents.svg";
import signup from "./images/signup.png";
import newlogo from "./images/newlogo.png";
import emptyLicenses from "./images/emptyLicenses.png";
import createFormLanding from "./images/createFormLanding.png";
import clientFormCard from "./images/clientFormCard.png";
import file from "./icons/file.png";
import atom_logo from "./images/atom_logo.png";
import todo from "./images/todo.png";
import completed from "./images/completed.png";
import terminated from "./images/terminated.png";
import deleted from "./images/deleted.png";
import onhold from "./images/onhold.png";
import onedrive from "./icons/onedrive.png";
import folderIcon from "./icons/folder.svg";
import emptyGroup from "./images/GroupEmpty.png";
import googleCalendar from "./images/google-calendar.png";
import atom_logo_no_background from "./images/atom_logo_no_background.jpeg";
import vider_logo from "./images/vider_logo.jpeg";
import inprog from "./images/inprog.png";
import underrev from "./images/underreview.png";
import terminate from "./images/terminate.png";
import Quantum from "./images/Quantum.png";
import documents from "./images/documents.png";
import vider_logo_white from "./images/vider_logo_white.jpeg";
import serviceopg1 from "./images/serviceopg1.jpg";
import dsc_Poster_Image from "./icons/dsc_Poster_Image.png";
import file_Poster_Image from "./icons/file_Poster_Image.png";
import recuring from "./icons/recurring.svg";
import vider_transparent from "./images/vider_transparent.png";
import vider_v from "./images/vider_v.png";
import clone_file from "./images/clone_file.png";
import canceled from "./images/canceled.png";
import atom_maintainence from "./images/Atom Maintenance.jpg";
import it from "./images/incomeTax.png";
import tds from "./images/incomeTaxTds.png";
import gst from "./images/incomeTaxGst.jpeg";
import downloadPdf from "./images/Downlaodpdf.png";
import downloadWord from "./images/DownlaodDocs.png";
import quantumRequestImg from "./images/quantunRequest.jpg";
import incomeTaxPortal from "./images/incomeTaxPortal.png";
import itO from "./images/incomeTaxOpacity.png";
import incomeTaxTan from "./images/IncomeTaxTAN.png";
import incomeTaxCa from "./images/IncomeTax CA.png";
import incomeTaxPan from "./images/Income Tax _ PAN.png";
import traces from "./images/Traces.png";
import gstImg from "./images/GST.png";
import todoIcon from "./images/todoI.png";
import inprogressIcon from "./images/inPro.png";
import underreviewIcon from "./images/ur.png";
import deletedIcon from "./images/del.png";
import pendingIcon from "./images/pendi.png";
import onholdIcon from "./images/onhol.png";
import completedIcon from "./images/com.png";
import terminateI from "./images/TerminateIcon.png";
import totalTasksIcon from "./images/all.png";

import incomeTaxPanOrg from "./images/IncomeTaxPANOrg.png";
import verificationPending from "./images/statusPending.png";
import verificationComplete from "./images/statusComplete.png";
import day7 from "./images/day7.png";
import invalidPassword from "./images/invalidPassword.png";
import validPassword from "./images/validPassword.png";
import submitOn from "./images/SubmitOn.png";
import returnBelated from "./images/returnBelated.png";
import returnDefective from "./images/returnDefective.png";
import returnOriginal from "./images/returnOriginal.png";
import returnRectification from "./images/returnRectification.png";
import returnRevised from "./images/returnRevised.png";
import atomProLogo from "./images/atomProLogo.png";
import returnUpdated from "./images/returnUpdated.png";
import notApplicable from "./images/notApplicable.png";
import issuedOn from "./images/issuedOn.png";
import last15days from "./images/day15.png";
import month1 from "./images/month1.png";
import registerIcon from "./images/register.png";
import gstrReturns from "./images/gstr-returns.png";
import mulitpleClients from "./images/multiple-users-silhouette.png";
import mulitipleClient from "./images/people.png";
import importPic from "./images/importPic.png";
import gmail from "./images/gmail.png";
import outlook from "./images/outlook.png";
import yahoo from "./images/yahoo.png";
import broadcastLogo from "./images/broadcastLogo.svg";
import EmptyFolder from "./images/empty-folder 3.png";
import mailLogo from "./images/mailLogo.png";
import ViderAI from "./icons/ai.svg";
import tanTracesLogo from "./images/incomeTaxTanTraces.png";
import mobileMfa from "./images/mobileMfa.png";
import atomCenter from "./images/atomCenter.png";
import word from "./images/word.png";
import xls from "./images/xls.png";
import Reminder from "./images/Reminder.png";
import remainder_icon from "./images/remainder_icon.png"
export {
  todo,
  inprog,
  completed,
  terminate,
  deleted,
  onhold,
  underrev,
  quote,
  recuring,
  logo,
  loginBg,
  whiteLogo,
  empty,
  profileImage,
  noAttachments,
  noSubTasks,
  noChecklists,
  noMilestones,
  noDueDiligence,
  noEvents,
  signup,
  newlogo,
  emptyLicenses,
  createFormLanding,
  clientFormCard,
  atom_logo,
  emptyGroup,
  atomByViderLogo,
  googleCalendar,
  atom_logo_no_background,
  Quantum,
  documents,
  serviceopg1,
  vider_logo_white,
  vider_logo,
  vider_transparent,
  vider_v,
  clone_file,
  downloadWord,
  downloadPdf,
  canceled,
  atom_maintainence,
  tds,
  it,
  gst,
  quantumRequestImg,
  incomeTaxPortal,
  itO,
  incomeTaxTan,
  incomeTaxCa,
  incomeTaxPan,
  traces,
  gstImg,
  todoIcon,
  inprogressIcon,
  underreviewIcon,
  deletedIcon,
  pendingIcon,
  onholdIcon,
  completedIcon,
  terminateI,
  totalTasksIcon,
  incomeTaxPanOrg,
  verificationPending,
  verificationComplete,
  day7,
  invalidPassword,
  validPassword,
  submitOn,
  returnBelated,
  returnDefective,
  returnOriginal,
  returnRectification,
  returnUpdated,
  returnRevised,
  atomProLogo,
  issuedOn,
  notApplicable,
  last15days,
  month1,
  gstrReturns,
  mulitpleClients,
  mulitipleClient,
  importPic,
  gmail,
  outlook,
  yahoo,
  EmptyFolder,
  mailLogo,
  tanTracesLogo,
  mobileMfa,
  atomCenter,
  word,
  xls,
  Reminder,
  remainder_icon
};

export const icons = {
  totalTasks,
  totalClients,
  taskCompleted,
  taskInprogress,
  taskTodo,
  taskUnderReview,
  checklist_PosterImage,
  handshake_PosterImage,
  socialmedia_PosterImage,
  calendar_PosterImage,
  folder,
  recurring,
  dashboard,
  approvals,
  taskboard,
  calendar,
  reports,
  invoicing,
  team,
  storage,
  settings,
  clients,
  register,
  dsc,
  gstReturns,
  broadcast,
  logout,
  man,
  profile,
  date,
  shuffle,
  user,
  pdf,
  doc,
  excel,
  csv,
  text,
  ppt,
  zip,
  video,
  audio,
  recuring,
  formIcon,
  singleLine,
  multiLine,
  email,
  name,
  fileUpload,
  imageUpload,
  termsAndConditions,
  currency,
  signature,
  dropDown,
  decisionBox,
  mobileNumber,
  numbers,
  fieldDate,
  checkBox,
  address,
  file,
  onedrive,
  folderIcon,
  serviceopg1,
  vider_logo_white,
  dsc_Poster_Image,
  file_Poster_Image,
  vider_transparent,
  atomPro,
  mail,
  registerIcon,
  gstrReturns,
  broadcastLogo,
  ViderAI,
};
